import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
interface HeaderProps {
  name: string;
}

const Header: React.FC<HeaderProps> = ({ name }) => {
  const { t } = useTranslation("common");
  return (
    // <Box
    //   mx={5}
    //   borderRadius="12px"
    //   p={"15px 20px"}
    //   background={
    //     "linear-gradient(90.6deg, rgba(64, 89, 155, 0.06) 0.59%, rgba(64, 89, 155, 0.04) 100.48%);"
    //   }
    //   border={"1px solid #40599B"}
    // >
    <Box>
      <Text
        // bgGradient="linear(to-r, #518B8A, #000000)"
        bgClip="text"
        fontSize="30px"
        fontWeight="extrabold"
        color="black"
      >
        {t("reportCard.welcomeBack", { name })}
      </Text>

      <Text color="#5C6670">{t("dashboard.subtext")}</Text>
    </Box>
    // </Box>
  );
};

export default Header;
